import {AppBar, Container, CssBaseline, IconButton, makeStyles, Toolbar, Typography} from "@material-ui/core";
import {ChevronLeft as ChevronLeftIcon} from "@material-ui/icons";
import Iframe from "react-iframe";
import GLOBAL from "../globales";

const useStyles = makeStyles(theme => ({
    appBarSpacer: theme.mixins.toolbar,
}));

export default function Recuperar() {

    const classes = useStyles();

    let urlQuery = '?user_action=reset_password&user_email=1&user_token=1';

    return (
        <>
            <CssBaseline/>
            <Container component={'main'} maxWidth={'sm'}>
                <AppBar position="absolute" color="default" elevation={2}>
                    <Toolbar>
                        <IconButton component="a" href={GLOBAL.ROOT_REF} style={{marginRight: '1rem'}}>
                            <ChevronLeftIcon/>
                        </IconButton>
                        <Typography variant="h6" component={'div'}>
                            Recuperar contraseña
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Container className={classes.appBarSpacer}>
                    <></>
                </Container>
                <Iframe url={GLOBAL.URL_APP + urlQuery}
                        width="100%"
                        height="750px"
                        id="myId"
                        className="myClassname"
                        display="initial"
                        position="relative"
                        frameBorder="0"
                />
            </Container>
        </>

    )
}